// Catégories de travaux BTP — du second œuvre au gros œuvre
export const CATEGORIES = [
  // Gros œuvre / structure
  "Gros œuvre",
  "Terrassement",
  "Démolition",
  "Construction neuve",
  "Maçonnerie",
  "Génie civil",
  "VRD (Voirie / Réseaux)",
  "Charpente",
  "Couverture / Toiture",
  "Étanchéité",
  "Façade / Ravalement",
  "Fondations",
  "Béton armé",
  // Second œuvre
  "Plomberie",
  "Électricité",
  "Chauffage",
  "Climatisation",
  "Ventilation (VMC)",
  "Isolation thermique",
  "Isolation phonique",
  "Plâtrerie / Cloisons",
  "Menuiserie intérieure",
  "Menuiserie extérieure",
  "Carrelage / Faïence",
  "Parquet / Revêtements sol",
  "Peinture",
  "Vitrerie / Miroiterie",
  "Serrurerie / Métallerie",
  // Aménagement
  "Cuisine équipée",
  "Salle de bain",
  "Domotique",
  "Piscine",
  "Aménagement paysager",
  "Pavage / Bordures",
  "Autre",
];

export const slugify = (s) =>
  s
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
